import { stringCamelCase } from '@polkadot/util';
function convert(fn) {
    return ({ name }) => fn(name);
}
export const objectNameToCamel = convert(stringCamelCase);
export const objectNameToString = convert((n) => n.toString());